import { Component, DoCheck } from '@angular/core';
import { InputGLobal } from '../utils/input-global';

@Component({
  selector: 'lib-input-tel',
  templateUrl: './lib-input-tel.component.html',
  styleUrl: './lib-input-tel.component.scss',
})
export class InputTelComponent extends InputGLobal implements DoCheck {
  protected displayValue = '';

  protected get resolvedPlaceholder(): string {
    if (this.placeholder) {
      return this.placeholder;
    }

    return this.usePhoneMask ? '(00) 00000-0000' : '00000000000';
  }

  ngDoCheck(): void {
    const digits = this.extractDigits(this.control?.value).slice(0, 11);
    const nextDisplayValue = this.resolveDisplayValue(digits);

    if (nextDisplayValue !== this.displayValue) {
      this.displayValue = nextDisplayValue;
    }
  }

protected onInput(event: Event): void {
  const input = event.target as HTMLInputElement;
  const digits = this.extractDigits(input.value).slice(0, 11);
  const nextDisplayValue = this.resolveDisplayValue(digits);

  this.displayValue = nextDisplayValue;
  input.value = nextDisplayValue;

  if (this.control) {
    this.control.setValue(digits);
    this.control.markAsDirty();
    this.control.updateValueAndValidity();
    this.checkValidation();
  }

  this.setValue(digits);
}

protected onBlurField(): void {
  if (this.control) {
    this.control.markAsTouched();
    this.checkValidation();
  }

  this.onBlur();
  this.emitFieldBlur();
}

  private resolveDisplayValue(value: string): string {
    const digits = this.extractDigits(value).slice(0, 11);

    if (!this.usePhoneMask) {
      return digits;
    }

    return this.applyPhoneMask(digits);
  }

  private extractDigits(value: unknown): string {
    return String(value ?? '').replace(/\D/g, '');
  }

  private applyPhoneMask(value: string): string {
    const digits = this.extractDigits(value).slice(0, 11);

    if (!digits.length) {
      return '';
    }

    if (digits.length <= 2) {
      return `(${digits}`;
    }

    if (digits.length <= 6) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2)}`;
    }

    if (digits.length <= 10) {
      return `(${digits.slice(0, 2)}) ${digits.slice(2, 6)}-${digits.slice(6, 10)}`;
    }

    return `(${digits.slice(0, 2)}) ${digits.slice(2, 7)}-${digits.slice(7, 11)}`;
  }
}